import React from 'react';
import { DashboardSidebar } from '@/layouts/dashboard';
import { useProgramOfStudies } from '@/hooks/useProgramOfStudies';
import { useTranslation } from 'react-i18next';
import { TaxonomiesItem, TaxonomiesText } from '@/components/custom/taxonomies/taxonomies';

export const Sidebar = () => {
  const { t } = useTranslation();
  const { firstLevelTaxonomies, changeSelectedTaxonomy, selectedTaxonomy } = useProgramOfStudies();

  return (
    <DashboardSidebar>
      <nav className="notebook-sidebar__nav">
        <button
          type="button"
          onClick={() => history.back()}
          className="btn btn--primary btn--full mb-6"
        >
          {t('button.back')}
        </button>

        {firstLevelTaxonomies.map((t, i) => (
          <TaxonomiesItem
            key={i}
            active={selectedTaxonomy.id === t.id}
            onClick={() => changeSelectedTaxonomy(t)}
          >
            <TaxonomiesText title={t.name}>{t.name}</TaxonomiesText>
            {/** <span className="notebook-sidebar__count">4/10</span> * */}
          </TaxonomiesItem>
        ))}
      </nav>
    </DashboardSidebar>
  );
};
